import React from 'react'
import { NavBarScreen } from '../navBar/NavBarScreen'
import { HospedajeCarousel } from './carouselTiger/HospedajeCarousel'
import { RestauranteCarousel } from './carouselTiger/RestauranteCarousel'
import { EntertainmentCarousel } from './carouselTiger/EntertainmentCarousel'
import { ClothingCarousel } from './carouselTiger/ClothingCarousel'
import { NutritionCarousel } from './carouselTiger/NutritionCarousel'
import { HealthCarousel } from './carouselTiger/HealthCarousel'
import { TransportCarousel } from './carouselTiger/TransportCarousel'
import { TechCarousel } from './carouselTiger/TechCarousel'
import { FooterScreen } from '../footer/FooterScreen'
import { SearchBeneffit } from './carouselTiger/SearchBeneffit'


export const BenefitScreen = () => {


    return (
        <>
            <NavBarScreen />


            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>

            <div className='container'>
                {/* <h1 className="camping-letters text-center" >TIGER CLUB</h1> */}
                <h4 className="camping-letters text-center" >🌄 ¡Nuevos beneficios para nuestros TIGRES!</h4>
            </div>

            <div className='container '>
                <br></br>
                <div className='row'>
                    <div className='col-12 col-sm-12 col-md-6'>
                        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel" data-bs-interval="10000">

                            <div className="carousel-inner">
                                <div className="carousel-item carousel-item2 active">
                                    {/* <img src={`${ApiStorage + tour.img_1}`} style={{ width: '100%' }} className="card-img-top" alt="..."></img> */}
                                    <img src={`./assets/images/carouselTyger/partner.png`} className="rounded img-fluid img-thumbnail" alt="" width="100%" height="auto" />

                                </div>
                                <div className="carousel-item carousel-item2 ">
                                    {/* <img src={`${ApiStorage + tour.img_2}`} style={{ width: '100%' }} className="card-img-top" alt="..."></img> */}
                                    <img src={`./assets/images/carouselTyger/partner2.png`} className="rounded img-fluid img-thumbnail" alt="" width="100%" height="auto" />

                                </div>
                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6'>

                        <h2></h2>
                        <p className='text-justify text-justify'>
                            En Camping Chimborazo creemos que la aventura está en el camino… y por eso, queremos acompañarte en cada paso 🥾
                            <br></br>
                            Ahora nuestros clientes podrán disfrutar de beneficios exclusivos gracias a nuestros partners en hospedaje 🏨, salud 💪 y nutrición 🥗, para que vivas una experiencia más completa, cómoda y saludable.
                            <br></br>

                        </p>
                        <p>

                            <b>🗓️ ¿Cuándo?</b><br></br>
                            Podrás acceder a estos beneficios 5 días antes y 5 días después de tu ruta. Así podrás prepararte mejor antes de subir a la montaña y seguir disfrutando del viaje incluso después del regreso.


                        </p>

                        <SearchBeneffit/>

                        <br></br>
                        <div className='text-justify text-center'>
                            <a href="https://wa.link/rataqq" target="_blank" style={{ textDecoration: 'none' }}>
                                <button type="button" style={{ width: "50%", margin: "5px" }} className="btn btn-success">
                                    <b>CLIC AQUÍ PARA MÁS INFO<i className="fab fa-whatsapp fa-1x"  ></i></b>
                                </button>
                            </a>
                        </div>

                        <br></br>

                    </div>
                </div>


                <div className='container'>
                    <HospedajeCarousel />

                    <RestauranteCarousel />

                    <EntertainmentCarousel />

                    <ClothingCarousel />

                    <NutritionCarousel />

                    <HealthCarousel />

                    <TransportCarousel />

                    <TechCarousel />


                </div>

                <br></br>
                <br></br>
                <br></br>
            </div>

            <FooterScreen />




        </>
    )
}
